import React from 'react';
import { StyledListContainer } from '../App.styled';
import { Loader } from './Loader';
import { PresetItem } from './PresetItem';

export const PresetsList = ({ presets, selected, loading, onSelection, displayAsset, cloudName }) => {
    return (
        <StyledListContainer>
            {
                loading
                    ?
                    <Loader/>
                    :
                    presets.map((preset) =>
                        <PresetItem
                            key={preset.id}
                            preset={preset}
                            selected={preset.transformation === selected}
                            onSelection={onSelection}
                            displayAsset={displayAsset}
                            cloudName={cloudName}
                        />
                    )
            }
        </StyledListContainer>
    );
};
